import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { MenuContextProvider } from './MenuContext.js';

const BASE_CLASS = 'nui-menu';
const TRACK_ACTIVE_ITEM_CLASS = `${BASE_CLASS}--track-active-item`;
const menuPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  role: PropTypes.string,
  trackActiveItem: PropTypes.bool
};
const Menu = /*#__PURE__*/forwardRef(({
  className,
  children,
  role = 'menu',
  trackActiveItem = false,
  ...restProps
}, ref) => /*#__PURE__*/React__default.createElement("ul", _extends({
  className: cx(BASE_CLASS, trackActiveItem && TRACK_ACTIVE_ITEM_CLASS, className),
  role: role
}, restProps, {
  ref: ref
}), /*#__PURE__*/React__default.createElement(MenuContextProvider, {
  value: role
}, children)));
Menu.propTypes = menuPropTypes;
Menu.displayName = 'NuiMenu';
var Menu$1 = Menu;

export { Menu$1 as default };
